// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1372":"61ec8394","3224":"b222c5ef","3803":"61ec8394","4344":"b222c5ef","8393":"b222c5ef","9835":"b222c5ef"}[chunkId] + ".chunk.css";
};